import { useSelector } from "react-redux";


const BranchTargets = () => {
    //   const OrgId = useSelector((state) => state.auth.org_id)
    // console.log(OrgId, 'org_id__________')

    return (
        <>
            {/* <h4 style={{ "text-align": "center", "padding-bottom": "20px" }}>Brand wise ASP- Accessories</h4> */}
            <div className="iframe-div">
                <iframe title="Report Section" width="600" height="373.5" src="https://iipl.retool.com/embedded/public/3282e9b6-33dd-4c38-84e8-f04775d23315" frameborder="0" allowFullScreen="true"></iframe>
            </div>
        </>

    )
};

export default BranchTargets;